export default "__VITE_ASSET__17da2a75__"